import React, { Dispatch, SetStateAction } from 'react';
import { ConversationalProductsSearchResponse } from '../services/search/interfaces';

export enum ChatMessageType {
  USER = 'user',
  AI = 'ai'
}

export interface ChatMessage {
  id: string;
  type: ChatMessageType;
  content: string;
  image?: File;
  timestamp: number;
}

export const SmartSearchContext = React.createContext<{
  chatHistory: ChatMessage[];
  setChatHistory: Dispatch<SetStateAction<ChatMessage[]>>;
  lastResponse: ConversationalProductsSearchResponse | null;
  setLastResponse: Dispatch<SetStateAction<ConversationalProductsSearchResponse | null>>;
  originalQuery: string;
  setOriginalQuery: Dispatch<SetStateAction<string>>;
  isSmartSearchOpen: boolean;
  setIsSmartSearchOpen: Dispatch<SetStateAction<boolean>>;
}>({
  chatHistory: [],
  setChatHistory: () => null,
  lastResponse: null,
  setLastResponse: () => null,
  originalQuery: '',
  setOriginalQuery: () => null,
  isSmartSearchOpen: false,
  setIsSmartSearchOpen: () => null
});
